// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error TODO this was working pre typescript
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { getMemoOccupationSelections } from './utils';

export type OccupationProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const Occupation = (props: OccupationProps): JSX.Element => {
  useMountLogging('Occupation');
  const occupation = useStoreState(({ form }) => form.occupation);
  const occupationSelections = getMemoOccupationSelections();

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      containerStyleOverrides={{ marginBottom: '12px' }}
      data-testid="occupation"
      emptyOption={{ enabled: true }}
      focusHandler={props.focusHandler}
      id="occupation"
      label={getContent('fieldLabels.occupation')}
      required={true}
      selectOptions={occupationSelections}
      {...occupation}
    />
  );
};

export { Occupation };
